import { z } from 'zod';

import { CompanyId, PayeeId } from '../../BrandedIds';
import { PayeePaymentMethod, PayeeTaxType, PayeeType } from '../../payee/Payee';
import { zodTemporalInstant } from '../../Temporal';
import { ExportableAddress } from '../util/ExportableAddress';

export const ExportablePayee = z
  .object({
    id: PayeeId,
    companyId: CompanyId,
    name: z.string(),
    payeeType: PayeeType,
    taxType: PayeeTaxType.optional(),
    externalPayeeId: z.string().optional(),
    address: ExportableAddress.optional(),
    phone: z.string().optional(),
    paymentMethod: PayeePaymentMethod,
    isActive: z.boolean(),
    createdAt: zodTemporalInstant,
    updatedAt: zodTemporalInstant,
  })
  .meta({ title: 'Payee' });

export type ExportablePayee = z.infer<typeof ExportablePayee>;
